<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00058.installation.ecremage.title' | translate"
      [description]="'P00058.installation.ecremage.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00058.installation.ecremage' | translate"
      [information]="getEnSavoirPlus"
      [titleListe]="'P00058.installation.ecremage.timer' | translate"
      [value]="actionStack!.getValue('pvPDureeEcremage')"
      [liste]="getEcremageTimerEnum()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Parametrage1,
          'pvPDureeEcremage',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [titleListe]="'P00058.installation.ecremage.speed' | translate"
      [description]="
        'P00058.installation.ecremage.speedDescription' | translate
      "
      [value]="actionStack!.getValue('pvPVitesseEcremage')"
      [liste]="getSpeedEnum(70, 100)"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Parametrage1,
          'pvPVitesseEcremage',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
